import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ACTIVITY = [
  { name: 'Sarah', city: 'Cape Town', when: '2 hours ago' },
  { name: 'Johan', city: 'Pretoria', when: '5 hours ago' },
  { name: 'Megan', city: 'Durban', when: '8 hours ago' },
  { name: 'Thabo', city: 'Johannesburg', when: 'yesterday' },
  { name: 'Lisa', city: 'Stellenbosch', when: 'yesterday' },
  { name: 'Pieter', city: 'Bloemfontein', when: '2 days ago' },
];

export default function SocialProofBar() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % ACTIVITY.length), 6000);
    return () => clearInterval(t);
  }, []);

  const entry = ACTIVITY[index];

  return (
    <div className="mt-5 h-10 flex items-center" data-testid="social-proof-bar">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.4 }}
          className="inline-flex items-center gap-2.5 bg-white/70 border border-[#0B0B0B]/10 rounded-full px-4 py-2 shadow-sm"
        >
          <span className="relative flex w-2 h-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600"></span>
          </span>
          <span className="text-sm text-[#0B0B0B]/90">
            <span className="font-bold">{entry.name}</span> from {entry.city} just started the program
            <span className="text-[#0B0B0B]/50"> · {entry.when}</span>
          </span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
